var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_16438_17337)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.8332 5.27778C10.8332 4.81754 10.4601 4.44444 9.99989 4.44444C9.53965 4.44444 9.16656 4.81754 9.16656 5.27778V9.16666H5.27767C4.81743 9.16666 4.44434 9.53976 4.44434 10C4.44434 10.4602 4.81743 10.8333 5.27767 10.8333H9.16656L9.16656 14.7222C9.16656 15.1825 9.53965 15.5556 9.99989 15.5556C10.4601 15.5556 10.8332 15.1825 10.8332 14.7222V10.8333H14.7221C15.1824 10.8333 15.5554 10.4602 15.5554 10C15.5554 9.53976 15.1824 9.16666 14.7221 9.16666H10.8332V5.27778Z",
    fill: "#002CFB"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_16438_17337"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPlus);
export default __webpack_public_path__ + "static/media/iconPlus.8f0d12e7cafdb335e961a2e29aadc86f.svg";
export { ForwardRef as ReactComponent };